export const OTHER_INPUT_SUFFIX = '__other_input';

export const otherLabelValue = {
  label: 'Other',
  value: 'other',
};

export const getOtherInputFormName = (key: string) => {
  return `${key}${OTHER_INPUT_SUFFIX}`;
};
